import { motion } from "framer-motion";
import { ReactComponent as Logo } from '../assets/logoLoyalty.svg';

const Quienes = () => {
    return (
        <div className="bg-gradient-to-b from-gray-100/60 to-white grid grid-cols-1 md:grid-cols-2 p-10 gap-8">
            <motion.div
                className="text-justify"
                initial={{ x: -200, opacity:0}}
                animate={{ x:0, opacity:1 }}
                transition={{duration: 1}}
                viewport={{ once: false }}
            >
                <h2 className="font-semibold text-3xl">¿Quienes somos?</h2>
                <p>
                    Somos una empresa especializada en el rastreo de equipo de transporte, mercancías,
                    personas y en general de todo tipo de bienes y muebles con una amplia experiencia y trayectoria en el mercado.
                </p>
            </motion.div>
            <motion.div
                initial={{ x: 200, opacity:0}}
                animate={{ x:0, opacity:1 }}
                transition={{duration: 1}}
                viewport={{ once: false }}
            >
                <Logo className="w-full h-auto" />
            </motion.div>
        </div>
    );
};

export default Quienes;